import { NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer-nav-item',
  templateUrl: './nav-item.component.html',
  standalone: true,
  imports: [RouterLink, NgIf, NgTemplateOutlet],
})
export class FooterNavItemComponent {
  @Input() path: string[] = [];
  @Input() href = '#';
  @Input() align: 'left' | 'center' | 'right' = 'left';

  @Output() itemClick = new EventEmitter<void>();
}
